import { Layout, Section } from 'layout';
import { ExclusiveDealsListScreen } from 'pages/exclusive-deals/screens/exclusive-deals-list-screen';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

const ExclusiveDealsPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Route path={`${match.url}/list`} component={ExclusiveDealsListScreen} />
          <Redirect to={`${match.url}/list`} exact />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default ExclusiveDealsPage;
